import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";

import { MedTooltipService } from "../../../services/med-tooltip.service";
import { MedHostDirective } from "../../../directives/med-host.directive";

@Component({
  selector: "med-tooltip-content",
  templateUrl: "./med-tooltip-content.component.html",
})
export class MedTooltipContentComponent implements AfterViewInit {
  constructor(public medTooltip: MedTooltipService) {}

  @ViewChild(MedHostDirective) hostTemplate!: MedHostDirective;
  @ViewChild("tooltipContentRef") tooltipContentRef!: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    this.medTooltip.tooltipContentEl = this.tooltipContentRef.nativeElement;
    this.medTooltip.host = this.hostTemplate;
  }
}
